/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddRoleToCompany200Response
 */
export interface AddRoleToCompany200Response {
    /**
     * `ステータス`
     * @type {number}
     * @memberof AddRoleToCompany200Response
     */
    status: number;
    /**
     * `メッセージ`
     * @type {string}
     * @memberof AddRoleToCompany200Response
     */
    message: string;
    /**
     * `権限コード`
     * @type {string}
     * @memberof AddRoleToCompany200Response
     */
    roleCode: string;
}

/**
 * Check if a given object implements the AddRoleToCompany200Response interface.
 */
export function instanceOfAddRoleToCompany200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "roleCode" in value;

    return isInstance;
}

export function AddRoleToCompany200ResponseFromJSON(json: any): AddRoleToCompany200Response {
    return AddRoleToCompany200ResponseFromJSONTyped(json, false);
}

export function AddRoleToCompany200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddRoleToCompany200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'roleCode': json['role_code'],
    };
}

export function AddRoleToCompany200ResponseToJSON(value?: AddRoleToCompany200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'role_code': value.roleCode,
    };
}

